import { createContext, useContext } from "react";

export const ThemeModeContext = createContext({
  mode: "light",
  setMode: () => {},
});

export function useThemeMode() {
  return useContext(ThemeModeContext);
}
